import { useEffect, useState, useContext } from "react";
import { AppContext } from "../contexts/AppContext";

const Counter = ({ resendOtpHandler }) => {
  const [counter, setCounter] = useState(300);
  const appContext = useContext(AppContext);
  const [showResendLink, setShowResendLink] = useState(false);
  let countInterval = null;

  useEffect(() => {
    countInterval = setInterval(() => setCounter((prev) => prev - 1), 1000);

    return () => {
      if (countInterval) clearInterval(countInterval);
    };
  }, []);
  useEffect(() => {
    if (counter === 0) {
      // appContext.updateModalState();
      setShowResendLink(true);
      clearInterval(countInterval);
    }
  }, [counter]);

  const handleClick = () => {
    setCounter(300);
    setShowResendLink(false);
    resendOtpHandler();
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  return showResendLink ? (
    <p className="text-center code-txt cursor-pointer" onClick={handleClick}>
      Resend
    </p>
  ) : (
    <p className="text-center code-txt">
      You can resend code {formatTime(counter)}
    </p>
  );
};

export default Counter;
